module.exports = "/virtual-football-league/img/amblems/left/Spain/Fake_Valencia.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/Spain/Fake_Valencia.png
// module id = 2048
// module chunks = 4